import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookingsSearchResponse, IRetrieveBookingSearchRequest } from "../../Orchestrator/Types/Index";


export async function postRetrieveBookingSearch(
    searchRequest: IRetrieveBookingSearchRequest
): Promise<IApiResponse<IBookingsSearchResponse>> {
    const ENDPOINTS = await getEndpoints();
    // Construct the endpoint for the custom bookings search
    const endpoint = `${ENDPOINTS.bookingsSearchCustom}`;

    // Make the API request using the constructed endpoint and searchRequest
    return await apiRequest<IBookingsSearchResponse>(endpoint, 'POST', {
        body: JSON.stringify(searchRequest),
    });
}
